import { TemplateView } from "../../../types/templates/template-view.interface";
import {
  ExecutionBriefDealerAdvertisingTemplate,
  ExecutionBriefEdmTemplate,
  ExecutionBriefInStoreDigitalTemplate,
  ExecutionBriefInStorePrintTemplate,
  ExecutionBriefPaidMediaTemplate,
  ExecutionBriefSimpleTemplate,
  ExecutionBriefWebTemplate,
} from "../../../features/new-execution-briefs/execution-templates";
import { EXECUTION_TEMPLATE } from "../../../types/templates/execution-brief/execution-brief-template.enum";

import {
  DealerAdvertisingSchema,
  EDMSchema,
  InStoreDigitalSchema,
  InStorePrintSchema,
  PaidMediaSchema,
  SimpleSchema,
  WebBannerSchema,
} from "../validation";

import { ExecutionBriefTemplateViewType } from "./execution-brief-template-view.type";

export function getExecutionBriefTemplateValidationSchema(template: EXECUTION_TEMPLATE | string) {
  switch (template) {
    case EXECUTION_TEMPLATE.DEALER_ADVERTISING:
      return DealerAdvertisingSchema;

    case EXECUTION_TEMPLATE.EDM:
      return EDMSchema;

    case EXECUTION_TEMPLATE.INSTORE_DIGITAL:
      return InStoreDigitalSchema;

    case EXECUTION_TEMPLATE.INSTORE_PRINT:
      return InStorePrintSchema;

    case EXECUTION_TEMPLATE.PAID_MEDIA:
      return PaidMediaSchema;

    case EXECUTION_TEMPLATE.WEB:
      return WebBannerSchema;

    case EXECUTION_TEMPLATE.SIMPLE:
    default:
      return SimpleSchema;
  }
}

export const getExecutionBriefTemplateViews = (): TemplateView<any /* ExecutionBriefTemplateViewType */>[] => [
  {
    name: EXECUTION_TEMPLATE.DEALER_ADVERTISING,
    view: ExecutionBriefDealerAdvertisingTemplate,
  },
  {
    name: EXECUTION_TEMPLATE.EDM,
    view: ExecutionBriefEdmTemplate,
  },
  {
    name: EXECUTION_TEMPLATE.INSTORE_DIGITAL,
    view: ExecutionBriefInStoreDigitalTemplate,
  },
  {
    name: EXECUTION_TEMPLATE.INSTORE_PRINT,
    view: ExecutionBriefInStorePrintTemplate,
  },
  {
    name: EXECUTION_TEMPLATE.PAID_MEDIA,
    view: ExecutionBriefPaidMediaTemplate,
  },
  {
    name: EXECUTION_TEMPLATE.SIMPLE,
    view: ExecutionBriefSimpleTemplate,
  },
  {
    name: EXECUTION_TEMPLATE.WEB,
    view: ExecutionBriefWebTemplate,
  },
];

export function getExecutionBriefTemplateView(
  template: EXECUTION_TEMPLATE | string
): ExecutionBriefTemplateViewType {
  const result = getExecutionBriefTemplateViews().find((view) => view.name === template);

  if (!result) {
    throw new Error(`View for ${template} not found`);
  }

  return result.view;
}
